export class PersonModel {
  constructor(
    public id: number,
    public geschlecht: string,
    public vorname: string,
    public name: string,
    public bemerkung: string,
    public gruppe: string,
    public spindId: number | null,
    public spindBezeichnung: string,
    public firma: string,
    public firmaId: number | null,
    public status: string,
    public groesseHemd: string,
    public hemdInventarnummer: string,
    public groesseHose: string,
    public hoseInventarnummer: string,
    public groesseJacke: string,
    public jackeInventarnummer: string,
    public groesseKittel: string,
    public kittelInventarnummer: string,
    public groesseSchuhe: string,
    public schuheInventarnummer: string,
  ) {}
}
